import script from "./PubyunDDns.vue?vue&type=script&setup=true&lang=js"
export * from "./PubyunDDns.vue?vue&type=script&setup=true&lang=js"

import "./PubyunDDns.vue?vue&type=style&index=0&id=5f563694&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f563694"]])

export default __exports__